<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <piaf-breadcrumb :heading="$t('menu.booking-visit')" />
            <div class="separator mb-5"></div>
        </b-colxx>
    </b-row>

    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="">
                <b-row class="mb-4 ml-1 lineAl">
                    <div>
                        <b-dropdown id="dropdown-1" :text="dropdownText" class="mr-2" variant="outline-danger default">
                            <b-dropdown-item @click="dropdownTextEvent(true)">일자 검색</b-dropdown-item>
                            <b-dropdown-item @click="dropdownTextEvent(false)">기간 검색</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div v-if="dropdownTrue">
                        <b-input-group>
                            <template v-slot:prepend>
                                <b-button @click="onClickPrev()" variant="outline-primary default">◀</b-button>
                                <b-input-group-text class="d-none d-xs-block">
                                    <b-icon icon="calendar"></b-icon>
                                </b-input-group-text>
                            </template>
                            <v-date-picker mode="single" v-model="searchDate" :input-props="{ class:'form-control', placeholder: '' }">
                            </v-date-picker>
                            <template v-slot:append>
                                <b-button @click="onClickNext()" variant="outline-primary default">▶</b-button>
                            </template>
                        </b-input-group>
                    </div>
                    <div v-if="!dropdownTrue">
                        <div class=" has-float-label reoportDiv">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text>
                                        <b-icon icon="calendar"></b-icon>
                                    </b-input-group-text>
                                </template>
                                <v-date-picker @click:date="dateClick" mode="single" v-model="startDate" :input-props="{ class:'form-control', placeholder: ''  }"></v-date-picker>
                            </b-input-group>
                            <!-- {{  }} -->
                            <!-- <span>시작날짜</span> -->
                        </div>
                        <div class=" has-float-label reoportDiv">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text>
                                        <b-icon icon="calendar"></b-icon>
                                    </b-input-group-text>
                                </template>
                                <v-date-picker mode="single" v-model="endDate" :input-props="{ class:'form-control', placeholder: ''  }"></v-date-picker>
                            </b-input-group>
                            <!-- <span>종료날짜</span> -->
                        </div>

                    </div>
                </b-row>

                <b-row>
                    <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
                        <div class="form-group has-float-label">
                            <v-select :options="searchOptions" v-model="searchKind" :reduce="item=>item.value" label="label"></v-select>
                        </div>
                    </b-colxx>

                    <b-colxx xxs="12" md="6" lg="4" xl="4">
                        <b-input-group>
                            <b-input :placeholder="searchPlaceholder" v-model.trim="searchKeyword" :maxlength="searchKind == 'PhoneNumber4' ? 4 : 13" @input="onlyNumberCheck" @keyup.enter="onSearch" />
                            <b-input-group-append>
                                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default">
                                    {{$t('button.search')}}
                                </b-button>
                            </b-input-group-append>

                            <!--                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm"-->
                            <!--                          :class="searchFlag ? '' : 'd-none d-sm-block'">-->
                            <!--                  {{ $t('button.search') }}-->
                            <!--                </b-button>-->
                            <!--                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="md"-->
                            <!--                          :class="searchFlag ? 'd-none d-sm-block' : ''">-->
                            <!--                  {{ $t('button.search-cancel') }}-->
                            <!--                </b-button>-->
                        </b-input-group>
                    </b-colxx>
                    <div class="thediv mb-3">
                        <div>
                            <b-dropdown id="dropdown-1" :text="dropdownTextApp" class="mr-2" variant="outline-danger default">
                                <b-dropdown-item @click="applicationDate(false)">방문일</b-dropdown-item>
                                <b-dropdown-item @click="applicationDate(true)">신청일</b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <download-excel :stringifyLongNum="true" :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="couponList.xls" type="xls">Excel
                        </download-excel>
                    </div>
                    <b-row class="mb-3 d-block d-sm-none d-md-none">
                        <!-- 모바일 사이즈일때 -->
                        <b-colxx xxs="12">
                            <b-input-group>
                                <b-input :placeholder="searchPlaceholder" v-model="searchKeyword" size="md" @input="onlyNumberCheck" />
                                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">
                                    {{ $t('button.search') }}
                                </b-button>
                                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="md">
                                    {{ $t('button.search-cancel') }}
                                </b-button>
                            </b-input-group>
                        </b-colxx>
                    </b-row>
                </b-row>

                <template v-if="isLoad">

                    <booking-list :items="items" :fields="fields" :per-page="perPage" :currentPage="currentPage" @click-row="onClickRow" @visited-cancel="visitedShow" />
                    <b-pagination v-if="lastPage > 1" size="sm" align="center" :total-rows="total" :per-page="perPage" v-model="currentPage">
                        <template v-slot:next-text>
                            <i class="simple-icon-arrow-right" />
                        </template>
                        <template v-slot:prev-text>
                            <i class="simple-icon-arrow-left" />
                        </template>
                        <template v-slot:first-text>
                            <i class="simple-icon-control-start" />
                        </template>
                        <template v-slot:last-text>
                            <i class="simple-icon-control-end" />
                        </template>
                    </b-pagination>
                </template>

                <template v-else>
                    <div class="loading"></div>
                </template>

                <template>
                    <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
                        <b-modal modal-class="notooltip" id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false" :no-close-on-backdrop="true">
                            <booking-visit-detail @noPenaltyVisitEve="noPenaltyVisitEve" v-bind:data="bookingInfo" @searchData="searchData" @hideModal="hideModal" @cancelRespar="cancelRespar" :modifyFlag="false" :checkUseFlag="bookingInfo.bookingStatus === 'Booked' ? true : false" />

                            <template slot="modal-footer">
                                <b-button variant="outline-primary" @click="hideModal()" v-show="cancelResparvar">닫기</b-button>

                                <b-button variant="primary" class="mr-1" @click="setVisited()"  v-if="bookingInfo.bookingStatus === 'Booked'" v-show="cancelResparvar">방문완료처리
                                </b-button>
                            </template>
                        </b-modal>
                    </b-row>
                </template>

                <!-- 예약방문 처리내역 조회모달  -->
                <booking-visited-cancel ref="modal_visited_cancel" :data="visitedInfo" :noShowFlag="noShowFlag" @process="visitedCancel" @noshow="cancelNoShow" />
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from '../../constants/api'
import BookingVisitDetail from './components/BookingDetailView'
import BookingList from "./components/BookingList";
import {
    alignTableCenter,
    eventBus
} from '../../utils';
import {
    _bookingStatus
} from "../../constants/common";
import BookingVisitedCancel from "./components/BookingVisitedCancel";

import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
import data from '../../data/notifications'
const now = new Date()
export default {
    components: {
        'v-select': vSelect,
        'booking-visit-detail': BookingVisitDetail,
        'booking-list': BookingList,
        'booking-visited-cancel': BookingVisitedCancel
    },

    data() {
        return {
            noPenalty:false,
            cancelResparvar:true,
            dropdownText: "일자 검색",
            dropdownTextApp:'방문일',
            dropdownTrue: true,
            text: '/',
            goodsData: [],
            json_fields: {
                '예약번호': 'bookingNo',
                '외부채널 예약번호': 'b2bBookingNo',
                '매장명': 'storeCode',
                '방문예정일': 'reservationDate',
                '방문예정시간': 'reservationDateTime',
                '예약자': 'visitorName',
                '전화번호': 'visitorPhone',
                '인원': 'headcount',
                '상태': 'bookingStatus',
                '예약경로': 'siteName',
                '이용수량': 'itemCount',
                '상품명': 'goodsName',
                '요청사항': 'visitorRequests'
            },
            noShowFlag: null,
            transProps: {
                // Transition name
                name: 'list'
            },
            searchKind: 'PhoneNumber4',
            searchOptions: [{
                    label: '전화번호',
                    value: 'PhoneNumber4'
                },
                {
                    label: '예약번호',
                    value: 'BookingNo'
                },
            ],
            searchDate: this.$route.query.searchDate ? this.$moment(this.$route.query.searchDate).toDate() : new Date(),
            isLoad: false,
            searchFlag: false,
            currentPage: 1,
            perPage: 30,
            lastPage: 1,
            total: 1,
            searchKeyword: "",
            items: [],
            fields: [{
                    key: 'bookingNo',
                    label: "예약번호",
                    ...alignTableCenter
                },
                {
                    key: 'storeName',
                    label: "매장명",
                    ...alignTableCenter
                },
                {
                    key: 'visitorName',
                    label: "예약자",
                    ...alignTableCenter
                },
                {
                    key: 'visitorPhone',
                    label: "전화번호",
                    ...alignTableCenter
                },
                {
                    key: 'reservationDate',
                    label: "방문예정일",
                    ...alignTableCenter
                },
                {
                    key: 'reservationDateTime',
                    label: "방문예정시간",
                    ...alignTableCenter
                },
                {
                    key: 'headcount',
                    label: "인원",
                    ...alignTableCenter
                },
                {
                    key: 'bookingStatus',
                    label: "상태",
                    ...alignTableCenter
                },
                {
                    key: 'freeBooking',
                    label: "예약경로",
                    ...alignTableCenter
                },
            ],
            bookingInfo: {
                bookingNo: null,
                visitorName: null,
                visitorPhone: null,
                visitorRequests: null,
                storeName: null,
                reservationDate: null,
                bookingRequestDate: null,
                bookingStatus: null,
                orderItems: [],
            },
            selectedBookingNo: null,
            visitedInfo: [],
            startDate: this.$moment(now).toDate(),
            endDate: this.$moment().add(30, 'days').toDate(),
            existing: this.$moment().subtract(21, 'days').toDate(),
            monthStartDate: this.$moment(now).toDate(),
            sortDateType: 'VisitDate',
            goodsExcelData: [],
            excelDatas : [],
        }
    },

    mounted() {
        this.searchData()
        // console.log(this.$moment().subtract(21, 'days').toDate())
        // console.log(this.$moment(new Date(now.getFullYear(), now.getMonth(), 1)).toDate())
      console.log(this.items)
    },

    watch: {
        currentPage() {
            this.searchData()
        },
        searchDate(value) {
            if (value) {
                this.searchData()
            }
        },
        startDate(value) {
            if (value) {
                this.endDate = "";
                this.existing = value;
                this.monthStartDate = value;
            } else {
                this.startDate = this.existing;
                // console.log(this.existing)
            }
        },
        endDate(value) {
            if (value) {
                this.searchData()
            }
        },
        noShowFlag() {}
    },

    computed: {
        ...mapGetters(['currentUser', 'siteName']),
        searchPlaceholder: {
            get: function () {
                return this.searchKind === "PhoneNumber4" ? "전화번호 뒷 4자리를 입력하세요." : "예약번호를 입력하세요";
            }
        }
    },

    methods: {
        applicationDate(type){
            if(type){
                this.sortDateType = 'RequestTime';
                this.dropdownTextApp = '신청일';
            }else{
                this.sortDateType = 'VisitDate';
                this.dropdownTextApp = '방문일';
            }
            if (this.dropdownTrue){
                this.dropdownTextEvent(true);
            }else{
                this.dropdownTextEvent(false);
            }
            console.log(this.sortDateType);
        },
        cancelRespar(val){
            this.cancelResparvar = val;
        },
        dateClick(date) {
            console.log(date)
        },
        dropdownTextEvent(type) {
            if (type) {
                this.dropdownText = '일자 검색';
                this.dropdownTrue = true;
                this.searchData();
            } else {
                this.dropdownText = '기간 검색';
                this.dropdownTrue = false;
                this.searchData();
            }
        },
        onlyNumberCheck(value) {
            let val = value.replace(/[^0-9]/g, '')
            this.searchKeyword = val
        },
        showModal() {
            this.$refs['bookingdetails'].show();
        },
        hideModal() {
            // this.noPenalty = false;
            this.$refs['bookingdetails'].hide();
        },
        onClickPrev() {
            this.searchDate = this.$moment(this.searchDate).subtract(1, 'day').toDate()
        },
        onClickNext() {
            this.searchDate = this.$moment(this.searchDate).add(1, 'day').toDate()
        },

        onSearch() {
            if (this.searchKeyword === "") {
                alert('검색어를 숫자만 입력하세요');
                return false
            }
            this.currentPage = 1
            // this.searchFlag = true
            this.searchData()
        },

        searchCancel() {
            this.searchFlag = false
            this.searchKeyword = ""
            this.searchData()
        },

        /** *************************************************************************************************************/
        searchData() {
            this.isLoad = true;
            this.items = [];

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingList)

            let _keywordType = this.searchKeyword === "" ? "NoKeyword" : this.searchKind //키워드 내용없을경우
            let datafrom = "";
            let datato = "";
            if (!this.dropdownTrue) {


                datafrom = this.$moment(this.startDate).format('YYYY-MM-DD');
                datato = this.$moment(this.endDate).format('YYYY-MM-DD');
                let newDate = new Date(Date.parse(this.monthStartDate) + 30 * 1000 * 60 * 60 * 24);

                if (this.$moment(newDate).format('YYYY-MM-DD') < this.$moment(this.endDate).format('YYYY-MM-DD')) {
                    alert('조회 기간은 1달(31일) 이내여야 합니다.');
                    return;
                }

                if (this.startDate > this.endDate) {
                    alert('시작일이 종료일 보다 클 수 없습니다.');
                    return;
                }
            } else {
                datafrom = this.$moment(this.searchDate).format('YYYY-MM-DD');
                datato = this.$moment(this.searchDate).format('YYYY-MM-DD');
            }
            const params = {
                dateType: "VisitDate",
                dateFrom: datafrom,
                dateTo: datato,
                keywordType: _keywordType,
                keyword: this.searchKeyword,
                pageNumber: (this.currentPage - 1),
                pageSize: this.perPage,
                sortDateType: this.sortDateType,
            }
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    //

                    const _data = res.data.data
                    this.lastPage = _data.totalPages
                    this.total = _data.totalElements
                    this.items = _data.content
                    this.goodsData = _data.content;
                    this.excelData();
                    // console.log(this.items)
                } else {
                    throw 400
                }
            }).catch(err => {
                console.log(err);
            })

        },
        excelData() {
            this.isLoad = true;
            this.goodsExcelData  = [];

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingListList)

            let _keywordType = this.searchKeyword === "" ? "NoKeyword" : this.searchKind //키워드 내용없을경우
            let datafrom = "";
            let datato = "";
            if (!this.dropdownTrue) {
                datafrom = this.$moment(this.startDate).format('YYYY-MM-DD');
                datato = this.$moment(this.endDate).format('YYYY-MM-DD');

            } else {
                datafrom = this.$moment(this.searchDate).format('YYYY-MM-DD');
                datato = this.$moment(this.searchDate).format('YYYY-MM-DD');
            }
            const params = {
                dateType: "VisitDate",
                dateFrom: datafrom,
                dateTo: datato,
                keywordType: _keywordType,
                keyword: this.searchKeyword,
                // pageNumber: (this.currentPage - 1),
                // pageSize: this.perPage,
                "timeFrom": null,
                "timeTo": null,
                sortDateType: this.sortDateType,
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    //

                    const _data = res.data.data
                    this.goodsExcelData = _data;
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err);
            })

        },
        async fetchData() {

            this.excelDatas = [];
            // console.log(this.goodsData)
            this.goodsExcelData.forEach((v, idx) => {
                let ssp = [];
                let totalHeadCount = 0;
                let totalHeadCountN = [];
                let optionNames = [];
                let iscoupoun = false;
                let goodsName = null;
                let yy = [];
                if (v.orderItems.length !== 0) {
                    v.orderItems.forEach((s, idx2) => {
                        ssp.push({
                            'headcount': s.headcount,
                            'goodsName': s.goodsName,
                            'optionName': s.optionName,
                        })
                    })
                    if (v.orderItems.length > 1) {
                        ssp.forEach((l, idx3) => {
                            totalHeadCount += l.headcount
                            totalHeadCountN.push(l.headcount);
                            optionNames.push(l.optionName + l.headcount);
                        })
                    } else {
                        totalHeadCount = ssp[0].headcount;
                        totalHeadCountN = ssp[0].headcount;
                        optionNames.push(ssp[0].optionName);
                    }
                    const opnameOverlap = {};
                    let overLapNum = {};
                    let nn = 1;
                    optionNames.forEach((x) => {
                        // opnameOverlap[x] = (opnameOverlap[x] || 0)+1;
                        if (opnameOverlap[x + " "]) {
                            opnameOverlap[x + " "] = opnameOverlap[x + " "] + nn;
                            overLapNum = JSON.stringify(opnameOverlap).slice(0, -1);
                        } else {
                            opnameOverlap[x + " "] = 0 + nn;
                            overLapNum = JSON.stringify(opnameOverlap).slice(0, -1);
                        }
                    });
                    let ss = JSON.stringify(opnameOverlap).split(',')
                    // console.log(ss)
                    let result_map = Object.keys(ss).map(function (key) {
                        return [String(), ss[key]];
                    });
                    // console.log(result_map)

                    result_map.forEach((s) => {
                        yy.push(this.regExp(" " + JSON.stringify(s)) + "매");
                    });
                    iscoupoun = true
                } else {
                    ssp.push({
                        'headcount': Number(v.adultHeadcount) + Number(v.childHeadcount) + Number(v.babyHeadcount),
                    });
                    iscoupoun = false
                }

                let newSiteName = "";
                if(v.b2bChannelCode =='KAKAOB'){
                  newSiteName = "카카오";
                } else if (v.siteName == "tablenjoy" && v.freeBooking == false) {
                    newSiteName = "테이블엔조이";
                } else if (v.freeBooking == true) {
                    newSiteName = "관리자";
                } else {
                    newSiteName = v.siteName;
                }
                //쿠폰 목록이 없는 경우
                if (!iscoupoun) {
                    totalHeadCount = ssp[0].headcount;
                    goodsName = "";
                } else {
                    totalHeadCount = Number(v.adultHeadcount) + Number(v.childHeadcount) + Number(v.babyHeadcount);
                    goodsName = ssp[0].goodsName + " : " + yy
                }
                // console.log(String(opnameOverlap).replace(/:/g,''))
                this.excelDatas.push({
                    'bookingNo': v.bookingNo + "&nbsp;",
                    'b2bBookingNo': v.b2bBookingNo,
                    'storeCode': v.storeName,
                    'reservationDate': this.$moment(v.reservationDate).format('YYYY-MM-DD'),
                    'reservationDateTime': this.$moment(v.reservationDate).format('HH:mm'),
                    'visitorName': v.visitorName,
                    'visitorPhone': String(v.visitorPhone).replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`),
                    'headcount': totalHeadCount,
                    'bookingStatus': _bookingStatus[v.bookingStatus],
                    'siteName': newSiteName,
                    'itemCount': v.itemCount,
                    'goodsName': goodsName,
                    'visitorRequests': v.visitorRequests,
                })

            })
            return this.excelDatas
        },
        regExp(str) {
            let reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
            //특수문자 검증
            if (reg.test(str)) {
                //특수문자 제거후 리턴
                return str.replace(reg, "");
            } else {
                //특수문자가 없으므로 본래 문자 리턴
                return str;
            }
        },
        onClickRow(item, bookingNo) {
            this.selectedBookingNo = bookingNo
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingDetail)
            const params = {
                bookingNo: bookingNo
            }
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.bookingInfo = res.data.data.bookingDetails;
                    this.cancelResparvar = true;
                    this.noPenalty = true;
                    this.showModal();
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        //예약취소
        cancelReservation() {

            // if (confirm('해당 예약을 취소하시겠습니까? ')) {
            //     const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelBooking)
            //     const params = {
            //         bookingNo: this.selectedBookingNo
            //     }

            //     eventBus.$emit('bus-event', true);
            //     this.$http.post(reqURL, params, {
            //         headers: {
            //             'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
            //         }
            //     }).then(res => {
            //         eventBus.$emit('bus-event', false);
            //         if (res.data.code === "OK") {
            //             alert('해당 예약이 취소 되었습니다.');
            //             this.hideModal()
            //             this.searchData()
            //         } else {
            //             throw 400
            //         }
            //     }).catch(err => {
            //         eventBus.$emit('bus-event', false);
            //         alert(err.response.data.message);
            //     })
            // }

        },

        //예약노쇼처리
        setNoShow() {

            // if (confirm('노쇼처리 하시겠습니까? ')) {
            //     const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.noShow)
            //     const params = {
            //         memo: "노쇼처리 함",
            //         bookingNo: this.selectedBookingNo
            //     }

            //     this.$http.post(reqURL, params, {
            //         headers: {
            //             'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
            //         }
            //     }).then(res => {
            //         if (res.data.code === "OK") {
            //             alert('노쇼처리 되었습니다.');
            //             this.hideModal()
            //             this.searchData()
            //         } else {
            //             throw 400
            //         }
            //     }).catch(err => {
            //         alert(err.response.data.message);
            //     })
            // }
        },

        //노쇼취소처리
        cancelNoShow(memo) {

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelNoShow)
            const params = {
                memo: memo,
                bookingNo: this.selectedBookingNo,
                transactionNo: this.visitedInfo.transactionNo
            }

            eventBus.$emit('bus-event', true);

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                eventBus.$emit('bus-event', false);
                if (res.data.code === "OK") {
                    alert('노쇼취소처리 되었습니다.')
                    this.searchData()
                } else {
                    throw 400
                }
            }).catch(err => {
                eventBus.$emit('bus-event', false);
                alert(err.response.data.message);
            })

        },
        noPenaltyVisitEve(val){
            if(val == true){
                this.noPenalty = false;
            }else{
                this.noPenalty = true;
            }
            console.log(this.noPenalty)
        },
        //예약방문처리
        setVisited() {
          let errFlag = true
          let selectedItemIds = [];
          let tmpArr = this.bookingInfo.orderItems.filter(item=>{return item.itemStatus !=='Consumed'})
          let orderItemTotal = tmpArr.length;
          let cancellationFeeRate = this.bookingInfo.cancellationFeeRate;
          let noPenalty = this.noPenalty;
          this.bookingInfo.orderItems.forEach(function (value, index) {
            if (value.unused) {
              selectedItemIds.push(value.itemNo)
              errFlag = false
            }
          })

          // if(errFlag) {
          //   alert('방문완료 처리 할 쿠폰을 선택해주세요.')
          //   return false
          // }
          if (confirm(this.getMessage(orderItemTotal, selectedItemIds.length, cancellationFeeRate, noPenalty))) {
            //방문완료 처리 필요
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.visitStore)
            const params = {
              bookingNo: this.selectedBookingNo,
              orderItems: selectedItemIds,
              memo: null,
              noPenalty: this.noPenalty,
              b2bStoreBooking: !this.bookingInfo.b2bChannelCode ? false: this.bookingInfo.b2bChannelCode === "KAKAOB" ?   true : false,
            }

            eventBus.$emit('bus-event', true);
            this.$http.post(reqURL, params, {
              headers: {
                'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
              }
            }).then(res => {
              eventBus.$emit('bus-event', false);
              if (res.data.code === "OK") {
                alert('처리 완료 하였습니다.')
                this.hideModal()
                this.searchData()
              } else {
                throw 400
              }
            }).catch(err => {
              eventBus.$emit('bus-event', false);
              alert(err.response.data.message);
            })
          }
        },
      getMessage(orderItemTotal, selectedItemTotal, cancellationFeeRate, noPenalty){
        let resultMessage = "";
        let cancelFee =  orderItemTotal - selectedItemTotal;
        if(cancellationFeeRate == "0.0" && !(orderItemTotal === selectedItemTotal)){
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : 위약금 면제"
        }
        else if(orderItemTotal === selectedItemTotal){
          resultMessage =  orderItemTotal +"매 방문완료 처리하시겠습니까?"
        }else if(noPenalty){
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : 위약금 면제"
        }else {
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : "+ cancellationFeeRate +"%"
        }

        return resultMessage;

      },
        //방문처리내역조회
        visitedShow(item, bookingNo) {
            this.noShowFlag = item.noShow
            this.selectedBookingNo = bookingNo
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.storeVisitInfo)
            const params = {
                bookingNo: bookingNo
            }
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    // console.log(res.data.data)
                    this.visitedInfo = res.data.data
                    this.$refs.modal_visited_cancel.open()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        visitedCancel(memo) {

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelVisitStore)
            const params = {
                memo: memo,
                bookingNo: this.selectedBookingNo,
                transactionNo: this.visitedInfo.transactionNo
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('방문취소처리 되었습니다.')
                    this.searchData()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        }

    }

}
</script>

<style scoped>
.posl {
    position: relative;
}

.thediv {
    position: absolute;
    right: 0;
    display: flex;
    justify-content: flex-start;
}

.lineAl {
    display: flex;
    align-items: center;
}
<style>
.notooltip .tooltip {
    top: 0px !important;
}
</style>
